// extracted by mini-css-extract-plugin
export default {"menuItem":"style_menuItem__NvinP","menuItem_active":"style_menuItem_active__WUg61"};